<template>
  <div class="container" >
    <div class="canvasBox" id="canvasBox" ref="box"></div>
    <Transition>
      <div style="float: right">
        <div class="tc-container tc-container-topRight" style="margin: 16px 0px 0px 0px; width: 15vw">
          <el-select ref="selectRef" v-model="selectValue" placeholder="请选择">
            <el-option v-for="item in selectList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>

        <div class="sidebarRight" id="sidebarRight" v-show="true">
          <div id="sidebarRightTop">

          </div>
          <div class="footer">
            <div class="center">
              <el-link  :underline="false"  @click="addWbPage()"  >添加页面</el-link>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>

export default {
  data() {
    return {
      app: null,
      selectRef: null,
      selectValue: '',
      selectList: [],
      currentType: 'selection',
      currentWhiteboardId: '',
      syncWhiteBoard : false,
      // 生成唯一 id
      uniqueIds: new Map,
      roomId : ''
    };
  },
  props: ['parentData'],
  watch: {
    selectValue(newVal, oldVal) {
      if (newVal !== oldVal && newVal !==null && newVal !== '' ) {
        this.setCurrentWhiteboardDiv(newVal)
      }
    },
    selectList(newVal, oldVal) {
      // 当 options 发生变化时，重新渲染 el-select
      if (newVal !== oldVal) {
        this.selectRef = null; // 清空原有选项
        this.selectRef = this.selectList; // 重新渲染 el-select，并设置选项为初始状态
      }
    }
  },
  mounted() {
    this.roomId = this.parentData.jyxRtcJoinRoomOptions.roomId;
    document.title = '捷宇在线白板';
    //添加监听
    this.subscribeEvent();
     //初始化
     this.parentData.rtcEngine.initWhiteBoard({
       containerId: 'canvasBox',
       roomId: this.roomId,
       userId:this.parentData.jyxRtcLoginOptions.userId,
       appId:this.parentData.jyxRtcLoginOptions.appId
     }).then(async (res)=> {
       this.app = res;
       //初始化工具栏
       await this.app.initToolbar({'containerId':'canvasBox'})
       const whiteboards = await this.app.getWhiteBoards();
       this.selectList = whiteboards.options;
       // this.selectValue = whiteboards.selectedValue;
       if(this.selectList.length === 0){
         //创建白板下拉
         await this.createWhiteboardDiv('whiteboard-0','whiteboard-0');
         await this.setCurrentWhiteboardDiv('whiteboard-0');
         const whiteboards = await this.app.getWhiteBoards();
         this.selectList = whiteboards.options;
         this.selectValue = whiteboards.selectedValue;
         this.addWbPage();
         // this.app.setCurrentPage({pageNo:0})
       }
     });
   /* this.app = new WbEngine()//添加监听
    this.subscribeEvent();
     this.app.init({
      containerId: 'canvasBox',
      roomId: this.roomId,
      userId:this.parentData.jyxRtcLoginOptions.userId,
      appId:this.parentData.jyxRtcLoginOptions.appId,
      socketClient:this.parentData.rtcEngine.socketClient
    }).then(async (res)=>{
       //初始化工具栏
       await this.app.initToolbar({'containerId':'canvasBox'})
       const whiteboards = await this.app.getWhiteBoards();
       this.selectList = whiteboards.options;
       // this.selectValue = whiteboards.selectedValue;
       if(this.selectList.length === 0){
         //创建白板下拉
         await this.createWhiteboardDiv('whiteboard-0');
         await this.setCurrentWhiteboardDiv('whiteboard-0');
         const whiteboards = await this.app.getWhiteBoards();
         this.selectList = whiteboards.options;
         this.selectValue = whiteboards.selectedValue;
         this.addWbPage();
         // this.app.setCurrentPage({pageNo:0})
       }
     });*/

  },
  methods: {
    subscribeEvent(){
      let subscribe = this.parentData.rtcEngine;
      subscribe.subscribeEvent('onAddWhiteBoard', async (result)=>{
        console.log("onAddWhiteBoard",result);
        let id = result.whiteBoardId;
        let parentDiv = document.getElementById("sidebarRightTop");
        let newElement = document.createElement("div");
        newElement.innerHTML = " <div class='elementStyle' id='" + id + "-wbDiv' style='display: none;overflow-y: scroll; overflow-x:hidden'></div>" + "";
        parentDiv.appendChild(newElement);

        const item = {};
        item.value = result.whiteBoardId;
        item.label = result.whiteBoardName;
        this.selectList.push(item);
      });
      subscribe.subscribeEvent('onSetCurrentWhiteBoard', (result)=>{
        if(this.selectValue !== result.whiteBoardId){
          this.syncWhiteBoard = true;
          this.selectValue = result.whiteBoardId;
        }
      });
      subscribe.subscribeEvent('onAddPage', (result)=>{
        this.addPage(result)
      });
      subscribe.subscribeEvent('onSetCurrentPage', (result)=>{

      });
      subscribe.subscribeEvent('onRemovePage', (result)=>{
        let div = document.getElementById(result.pageId);
        div.parentElement.parentElement.remove();
        this.calPageIndex();
      });
    },
    addWbPage(){
      this.createPageDiv(true);
    },
    createWhiteboardDiv(id,name) {
      //设置id开始值0
      this.uniqueIds.set(id, 0);
      this.app.createBlankWhiteBoard({
        id: id,
        name: name
      });
      let parentDiv = document.getElementById("sidebarRightTop");
      let newElement = document.createElement("div");
      let html = " <div class='elementStyle' id='" + id + "-wbDiv' style='display: none;overflow-y: scroll; overflow-x:hidden'></div>" + "";
      newElement.innerHTML = html;
      parentDiv.appendChild(newElement);
    },
    createPageDiv(insertAfter) {
      //添加分页
      this.app.addPage({
      }).then((res)=>{
        this.addPage(res);
      });
    },
    addPage(res){
      let el = res.element;
      let whiteboardId = res.whiteBoardId;
      let uniqueId = this.uniqueIds.get(whiteboardId) || 0;
      let parentId = whiteboardId + '-wbDiv';
      let pageId = el.id;
      let delBtnId = parentId + "-btn-del-" + uniqueId;
      let parentDiv = document.getElementById(parentId);
      let newElement = document.createElement("div");
      newElement.id = parentId+'-box-temp-'+uniqueId;
      let html = `<div class="preview-box active" style="height: 13vh; width: 13vw; position: relative; overflow: hidden;margin-bottom: 16px">
                      <span class="page-index">` + uniqueId + `</span>
                      <div class="preview-delete btn" id="`+delBtnId+`"></div>

                    </div>`
      newElement.innerHTML = html;
      parentDiv.appendChild(newElement);
      newElement.children[0].appendChild(el);

      let app =this.app;
      document.getElementById(delBtnId).addEventListener('click', function() {
        // 在这里编写点击事件的处理逻辑
        let div = document.getElementById(pageId);
        div.parentElement.parentElement.remove();
        app.deletePage({
          pageId: pageId
        });
        if(whiteboardId !== ''){
          let divElement = document.getElementById(whiteboardId+'-wbDiv');
          let classes = divElement.getElementsByClassName('page-index');
          for (let i = 0; i < classes.length; i++) {
            classes[i].innerHTML = i+1;
          }
        }
      });
      this.canvasClick(el.id);
      this.uniqueIds.set(whiteboardId, uniqueId + 1);
      this.calPageIndex();
    },
    setCurrentWhiteboardDiv(value) {
      this.currentWhiteboardId = value;
      let divs = document.getElementsByClassName('elementStyle'); // 获取所有的div元素
      for (let i = 0; i < divs.length; i++) { // 遍历每个div元素
        let divId = divs[i].id; // 获取div元素的ID
        if (divId === value + '-wbDiv') { // 如果div元素的ID与选中的选项的值匹配
          divs[i].style.display = 'block'; // 显示匹配的div元素
        } else {
          divs[i].style.display = 'none'; // 隐藏不匹配的div元素
        }
      }
      if(!this.syncWhiteBoard){
        this.app.setCurrentWhiteBoard(value);
        try {
          this.app.setCurrentPage({pageNo:0})
        }catch (e){}
      }
      this.syncWhiteBoard = false;
      this.calPageIndex();
    },
    canvasClick(id) {
      document.getElementById(id).addEventListener('click', this.clickEvent);
    },
    clickEvent(event) {
      const pageId = event.target.parentElement.id;
      //设置当前分页
      this.app.setCurrentPage({pageId: pageId});
    },
    calPageIndex(){
      if(this.currentWhiteboardId !== ''){
        let divElement = document.getElementById(this.currentWhiteboardId+'-wbDiv');
        let classes = divElement.getElementsByClassName('page-index');
        for (let i = 0; i < classes.length; i++) {
          classes[i].innerHTML = i+1;
        }
      }
    }
  }
};
</script>

<style>
ul,
ol {
  list-style: none;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
  transform: translateX(-300px);
}
</style>
<style>


.container {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  .toolbar {
    position: absolute;
    left: 50%;
    top: 10px;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;

    .blockBox {
      height: 100%;
      display: flex;
      align-items: center;
      padding: 0 10px;
    }
  }

  .canvasBox {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 100%;
    height: 100%;
    transform: translate(-50%, -50%);
    background-color: rgb(245, 245, 247);;
  }

  .sidebarRight {
    top: 70px;
    bottom: 70px;
    width: 15vw;
    min-height: 75vh;
    position: relative;
    border: 1px solid #e6e7eb;
    box-shadow: 0 8px 20px -4px rgba(0, 0, 0, 0.1);
    float: right;
    background-color: #FFFFFF;
    margin: 0 auto 0 0;

    .elementStyle {
      padding: 10px;
      border-radius: 4px;
      min-height: calc(75vh - 40px);
      height: calc(75vh - 40px);

      .active {
        border: 1px solid #337eee;
      }

      .page-index {
        position: absolute;
        background-size: cover;
        left: 8px;
        top: 4px;
        z-index: 999;
      }

      .preview-delete {
        position: absolute;
        background-size: cover;
        right: 6px;
        width: 20px;
        height: 20px;
        z-index: 999;
        background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjQgNCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDE1SDI4IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjEuMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNiAxMkgyNCIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxLjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTQgMTVWMjdDMTQgMjcuNTUyMyAxNC40NDc3IDI4IDE1IDI4SDI1QzI1LjU1MjMgMjggMjYgMjcuNTUyMyAyNiAyN1YxNSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxLjIiLz4KPHBhdGggZD0iTTE4LjYgMThDMTguNiAxNy42Njg2IDE4LjMzMTQgMTcuNCAxOCAxNy40QzE3LjY2ODYgMTcuNCAxNy40IDE3LjY2ODYgMTcuNCAxOEgxOC42Wk0xNy40IDI1QzE3LjQgMjUuMzMxNCAxNy42Njg2IDI1LjYgMTggMjUuNkMxOC4zMzE0IDI1LjYgMTguNiAyNS4zMzE0IDE4LjYgMjVIMTcuNFpNMTcuNCAxOFYyNUgxOC42VjE4SDE3LjRaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjIuNiAxOEMyMi42IDE3LjY2ODYgMjIuMzMxNCAxNy40IDIyIDE3LjRDMjEuNjY4NiAxNy40IDIxLjQgMTcuNjY4NiAyMS40IDE4SDIyLjZaTTIxLjQgMjVDMjEuNCAyNS4zMzE0IDIxLjY2ODYgMjUuNiAyMiAyNS42QzIyLjMzMTQgMjUuNiAyMi42IDI1LjMzMTQgMjIuNiAyNUgyMS40Wk0yMS40IDE4VjI1SDIyLjZWMThIMjEuNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=);
      }

      .preview-delete:hover {
        display: block;
      }

      .btn {
        cursor: pointer; /* 当鼠标移动到段落上时，鼠标指针会变成一个手指形状 */
      }
    }

    .footer {
      padding: 8px 16px;
      border-top: 1px solid #e6e7eb;
      left: 50%;
      position: relative;
      transform: translateX(-50%);

      .center {
        top: 10px;
        text-align: center;

        .text {
          color: #337eff
        }
      }
    }

    ::-webkit-scrollbar {
      width: 8px;
    }

    ::-webkit-scrollbar-track {
      background-color: #F5F5F5;
    }

    ::-webkit-scrollbar-thumb {
      background-color: gray;
      border-radius: 4px;
    }
  }

  .sidebar {
    position: absolute;
    left: 10px;
    top: 10px;
    width: 250px;
    background-color: #fff;

    .elementStyle {
      padding: 10px;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
      border-radius: 4px;

      .styleBlock {
        margin-bottom: 10px;

        .styleBlockTitle {
          color: #343a40;
          font-size: 14px;
          margin-bottom: 10px;
        }

        .styleBlockContent {
          display: flex;

          .lineWidthItem {
            display: flex;
            width: 30px;
            height: 10px;
            align-items: center;

            .bar {
              width: 100%;
              background-color: #212529;
            }

            &.small {
              .bar {
                height: 2px;
              }
            }

            &.middle {
              .bar {
                height: 4px;
              }
            }

            &.large {
              .bar {
                height: 6px;
              }
            }
          }

          /deep/ .el-radio-group {
            .el-radio-button {
              &.is-active {
                .lineWidthItem {
                  .bar {
                    background-color: #fff;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .footerLeft {
    position: absolute;
    left: 10px;
    bottom: 10px;
    height: 40px;
    display: flex;
    align-items: center;

    .blockBox {
      height: 100%;
      display: flex;
      align-items: center;
      padding: 0 10px;

      .zoom {
        width: 40px;
        margin: 0 10px;
        user-select: none;
        color: #606266;
        cursor: pointer;
        height: 32px;
        display: flex;
        align-items: center;
        background-color: #fff;
        border-radius: 5px;
        padding: 0 5px;
        justify-content: center;
      }
    }
  }
}

.exportImageContainer {
  .imagePreviewBox {
    height: 400px;
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAMUlEQVQ4T2NkYGAQYcAP3uCTZhw1gGGYhAGBZIA/nYDCgBDAm9BGDWAAJyRCgLaBCAAgXwixzAS0pgAAAABJRU5ErkJggg==') 0;
    padding: 10px;

    img {
      width: 100%;
      height: 100%;
      object-fit: scale-down;
    }
  }

  .handleBox {
    display: flex;
    align-items: center;
    height: 50px;
    justify-content: center;
  }
}

.exportJsonContainer {
  .jsonPreviewBox {
    height: 400px;
    overflow: auto;
    background-color: #f5f5f5;
    font-size: 14px;
    color: #000;

    /deep/ .jsontree_tree {
      font-family: 'Trebuchet MS', Arial, sans-serif !important;
    }
  }

  .handleBox {
    display: flex;
    align-items: center;
    height: 50px;
    justify-content: center;
  }
}

.helpDialogContent {
  height: 500px;
  overflow: auto;
}

</style>
